export const LanguageIds = {
  ENGLISH: 1,
  SPANISH: 2,
};
